import PrivateRoute, { Router } from "components/app-layout/PrivateRoute";

import BuilderBlocksBuilderLayout from "./containers/Builder";
import BuilderBlocksGridLayout from "./containers/Grid";

export default function BuilderBlocksLayout() {
  return <Router>
    <PrivateRoute path="/cms/builder-blocks/:id/builder-blocks" component={BuilderBlocksBuilderLayout} />
    <PrivateRoute path="/cms/builder-blocks" component={BuilderBlocksGridLayout} />
  </Router>
}
